import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("sj_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const resolveImage = (src, opts = {}) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  const url = `${API}/images/${src}`;
  if (opts && opts.blur) return `${url}?w=32&blur=1`;
  if (opts && opts.w) return `${url}?w=${opts.w}`;
  return url;
};

export default client;
